import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@/auth/msal";
import { App } from "@/App";
import { I18nProvider } from "@/lib/i18n";
import { env } from "@/lib/env";
import "@/index.css";

// MSAL initialization runs only when the portal AAD app's client id is
// configured. Until it is, the SPA renders the static landing only and
// skips the MSAL handshake entirely (an empty clientId would throw).
// Wrapped in an async IIFE to avoid a top-level await.
(async () => {
  const authConfigured = Boolean(env.msalClientId);
  if (authConfigured) {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
  }
  const tree = authConfigured ? (
    <MsalProvider instance={msalInstance}>
      <App authConfigured />
    </MsalProvider>
  ) : (
    <App authConfigured={false} />
  );
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <I18nProvider>{tree}</I18nProvider>
    </React.StrictMode>,
  );
})();
